import { initLiveChat } from "../../../services/livechat";

export const appIdSetLiveChat = (payload) => {
  if (payload?.liveChatStreamId && payload?.liveChatTrackerStreamId) {
    return initLiveChat(payload?.liveChatStreamId, payload?.liveChatTrackerStreamId);
  }
};
